// extracted by css-extract-rspack-plugin
export default {"wrapper":"src-wab-client-components-studio-BareModal-module__wrapper-ROe41T"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"wrapper\":\"src-wab-client-components-studio-BareModal-module__wrapper-ROe41T\"}";
        // 1793541990121
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  